/* eslint-disable jsx-a11y/click-events-have-key-events */
import { format } from 'date-fns';
import { Tooltip } from 'react-leaflet';
import { StyledBigTooltipInner } from '../../Styled';
import { getValueSafely } from 'utils/utils';
import closeImg from '../../icons/close.svg';
import { observer } from 'mobx-react';
import { style } from 'typestyle';
import { useMapStore } from 'contexts/RootStore.context';
import LoadingCircle from 'components/Loading/LoadingCircle';
import LocationSpan from './InfoBoxSpans/LocationSpan';

type LargeInfoBoxTooltipProps = {
  loading: boolean
  handleCloseInfoBox: () => void;
};

export function getDateString(date?: string) {
  if (!date) return '––';

  const addedOnDate = date
    ? format(new Date(date), 'dd/LL/yyyy - HH:mm')
    : '––';

  return addedOnDate;
}

export const DeviceDetailsTooltip = observer(({ loading, handleCloseInfoBox }: LargeInfoBoxTooltipProps) => {

  const { selectedDevice, selectedDeviceFull: device } = useMapStore()

  return (
    <>
      <Tooltip
        className="tooltip-large"
        interactive={true}
        direction="right"
        offset={[8, 0]}
        opacity={1}
        permanent
      >
        <StyledBigTooltipInner className={style({ width: "350px !important" })} id={`device-info-tooltip-${selectedDevice?.device_id}`}>
          <img
            alt="close"
            className="close-button"
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role="button"
            src={closeImg}
            onClick={() => {
              handleCloseInfoBox();
            }}
          />
          <div className="tooltip-inner-container">
            <div className="tooltip-inner-content">
              <div className="information-line">
                <h4>Device ID:</h4>
                <span>{selectedDevice?.device_id}</span>
              </div>
              <div className="information-line">
                <h4>Last Seen:</h4>
                <span>{getDateString(selectedDevice?.last_update_timestamp)}</span>
              </div>
              <div className="information-line">
                <h4>Location:</h4>
                <LocationSpan location={selectedDevice?.location} />
              </div>
            </div>
          </div>
          <div className="hr"></div>

          {loading
            ?
            <div className="tooltip-inner-container">
              <div className="tooltip-inner-content">
                <LoadingCircle size={15} />
              </div>
            </div>
            :
            <div className="tooltip-inner-container">
              <div className="tooltip-inner-content">

                {device?.user === null && (
                  <div className="information-line"><p>No user is logged into this device.</p></div>
                )}

                {device?.user?.type === "invalid_authorization_device_user" && (
                  <div className="information-line"><p>No access to view the user.</p></div>
                )}

                {device?.user?.type === "device_user" && (
                  <>
                    <div className="information-line">
                      <h4>User Name:</h4>
                      <span>{getValueSafely(device.user?.name)}</span>
                    </div>
                    <div className="information-line">
                      <h4>User Email:</h4>
                      <span>{getValueSafely(device.user?.email)}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          }
        </StyledBigTooltipInner>
      </Tooltip >
    </>
  );
})
